import styled from "styled-components";

const ContentContainer = styled.div`
  width: 50%;
  margin: 0 auto;
  display: flex;
  margin-top: 2%;
  @media only screen and (max-width: 480px) {
    display: block;
    margin: 0;
    width: 100%;
  }
`;
const ContentMainContainer = styled.div`
  margin-left: 2rem;
  width: 100%;
  h1 {
    text-align: left;
    font-size: 4rem;
    margin-top: 0;
    margin-bottom: 3%;
    font-weight: 100;
  }
  @media only screen and (max-width: 480px) {
    margin: 1em 0;
    h1 {
      display: none;
    }
    .SubTitle {
      padding-left: 1%;
    }
  }
`;

const ContentSideContainer = styled.div`
  text-align: left;
  width: 18%;
  .SideTitle {
    width: 100%;
    border-bottom: 5px solid rgb(33, 175, 196);
    p {
      margin: 3% 0;
      font-size: 1.5rem;
      text-align: left;
    }
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
    .SideTitle {
      p {
        padding-left: 0.5em;
      }
    }
  }
`;

const ContentCss = {
  ContentContainer,
  ContentMainContainer,
  ContentSideContainer
};
export default ContentCss;
